import List from '../../../components/Purchasing/RFQ/List'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function RFQ(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/purchasing/suppliers/list">Vendors</Breadcrumb.Item>
              <Breadcrumb.Item>Request For Quote</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Request For Quote'}
              subtitle={'Request For Quote'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

RFQ.propTypes = {}
RFQ.defaultProps = {}

export default RFQ
